module.exports = __webpack_public_path__ + "static/media/ReportServiceIcon.c7f0d36e.svg";